<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>订单查看</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="订单编号">
          <el-input v-model="formSearch.orderno" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item label="订单日期">
          <el-date-picker v-model="formSearch.startDate" type="date" placeholder="开始日期" value-format="yyyy-MM-dd"></el-date-picker>
          -
          <el-date-picker v-model="formSearch.endDate" type="date" placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>

        <el-form-item label="应用名称">
          <el-input v-model="formSearch.applyname" placeholder="应用名称"></el-input>
        </el-form-item>
        <el-form-item label="玩家ID">
          <el-input v-model="formSearch.uid" placeholder="玩家ID"></el-input>
        </el-form-item>
        <el-form-item label="支付方式">
          <el-select v-model="formSearch.payment" clearable placeholder="请选择">
            <el-option label="微信" value="wx"></el-option>
            <el-option label="腾讯微信" value="twx"></el-option>
            <el-option label="支付宝" value="zfb"></el-option>
            <el-option label="Alipay支付宝" value="dyzfb"></el-option>
            <el-option label="微信 支付" value="ybwx"></el-option>
            <el-option label="支付宝 支付" value="ybzfb"></el-option>
            <el-option label="小程序" value="wechat"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="交易结果">
          <el-select v-model="formSearch.transtate" clearable placeholder="请选择">
            <el-option label="交易成功" value="S"></el-option>
            <el-option label="交易失败" value="N"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getOrderPage">查询</el-button>

          <el-button type="success" @click="handleExcel">EXCEL</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" @row-dblclick="handleClick" size="mini">
        <el-table-column fixed label="订单编号" width="300">
          <template slot-scope="scope">
            平台订单号:{{scope.row.orderno}}<br/>
            商户订单号:{{scope.row.tranNo}}<br/>
            支付流水号:{{scope.row.tradeNo}}
          </template>
        </el-table-column>

        <el-table-column prop="productName" label="商品名称" width="160"></el-table-column>

        <el-table-column prop="merchname" label="商户名称" width="360"></el-table-column>

        <el-table-column prop="applyname"label="应用名称" width="160"></el-table-column>

        <el-table-column prop="uid" label="玩家ID" width="90"></el-table-column>

        <el-table-column prop="userName" label="玩家名称" width="90"></el-table-column>

        <el-table-column prop="initAmount" label="交易金额"></el-table-column>

        <el-table-column prop="amount" label="实付金额"></el-table-column>

        <el-table-column prop="createdate" label="订单日期" :formatter="formatDate" width="180"></el-table-column>
        <el-table-column prop="payment" label="支付方式" width="120">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.payment == 'wx'" type="success">
              <i v-if="scope.row.couponId != null && scope.row.couponId != ''" class="el-icon-bank-card"></i>
              微信
            </el-tag>
            <el-tag v-if="scope.row.payment == 'zfb'" type="success">
              <i v-if="scope.row.couponId != null && scope.row.couponId != ''" class="el-icon-bank-card"></i>
              支付宝
            </el-tag>
            <el-tag v-if="scope.row.payment == 'twx'" type="success">
              <i v-if="scope.row.couponId != null && scope.row.couponId != ''" class="el-icon-bank-card"></i>
              腾讯微信
            </el-tag>
            <el-tag v-if="scope.row.payment == 'dyzfb'" type="success">
              <i v-if="scope.row.couponId != null && scope.row.couponId != ''" class="el-icon-bank-card"></i>
              Alipay支付宝
            </el-tag>
            <el-tag v-if="scope.row.payment == 'ybwx'" type="success">
              <i v-if="scope.row.couponId != null && scope.row.couponId != ''" class="el-icon-bank-card"></i>
              微信 支付
            </el-tag>
            <el-tag v-if="scope.row.payment == 'ybzfb'" type="success">
              <i v-if="scope.row.couponId != null && scope.row.couponId != ''" class="el-icon-bank-card"></i>
              支付宝 支付
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="transtate" label="交易结果" width="150">
          <template slot-scope="scope">
            {{scope.row.transtate == 'S' ? '交易成功' :'交易失败'}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="float:right;margin:10px"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageresult.pageSize"
        layout="total, prev, pager, next"
        :total="pageresult.totalSize">
      </el-pagination>
    </el-card>

    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      size="60%">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>详情</span>
        </div>
        <el-form label-width="100px" size="mini">
          <el-divider content-position="left">订单基本信息</el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item label="订单编号">
                <el-input v-model="order.orderno" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品名称">
                <el-input v-model="order.productName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="应用名称">
                <el-input v-model="order.applyname" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="应用类型">
                <el-input v-model="order.apptype" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="支付方式">
                <el-input v-model="order.payment=='wx'?'微信': order.payment=='zfb' ? '支付宝' : order.payment=='twx' ? '腾讯微信' : order.payment=='dyzfb' ? 'Alipay支付宝' : order.payment==='ybwx'?'微信 支付':order.payment==='ybzfb'?'支付宝 支付':'小程序' " :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="玩家ID">
                <el-input v-model="order.uid" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="订单日期">
                <el-input v-model="order.createdate" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-divider content-position="left">订单支付信息</el-divider>
          <el-row>
            <el-col :span="12">
              <el-form-item label="订单金额">
                <el-input v-model="order.initAmount" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="实付金额">
                <el-input v-model="order.amount" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="优惠卷金额">
                <el-input v-model="order.useCouponAmount" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="活动名称">
                <el-input v-model="order.activity" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="星钻使用前">
                <el-input v-model="order.points" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="星钻消费">
                <el-input v-model="order.pointAmount" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="星钻使用后">
                <el-input v-model="order.afterPoint" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="星钻消费时间">
                <el-input v-model="order.createTime" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        </el-card>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      drawer:false,
      order:{},
      formSearch: {
        pageNum:1
      },
      tableData:[],
      pageresult:{}
    }
  },
  created(){
    this.getOrderPage();
  },
  methods: {
    handleCurrentChange(val) {
      this.formSearch.pageNum=val;
      this.getOrderPage();
    },
    formatDate(row, column) {
      return moment(row.createdate).format("YYYY-MM-DD HH:mm:ss");
    },
    handleClick(row, event, column) {
      // this.order = Object.assign({},row);
      // this.order.createdate = moment(this.order.createdate).format("YYYY-MM-DD HH:mm:ss");
      // this.drawer=true;
      let _this = this;
      this.$ajax({
        url:"coupon-merch/order/getOrderById",
        async:false,
        data:{'id':row.id},
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code == 0) {
            _this.order = response.data;
            _this.drawer = true;
          }else{
            _this.$message.error(response.message);
          }
        }
      })
    },
    getOrderPage(){
      let that = this;
      let info = this.$store.state.userInfo;
      this.formSearch.merchno=info.userbh;
      this.$ajax({
        url:"coupon-merch/order/getOrderPage",
        async:false,
        data:that.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            that.tableData=response.data.content;
            that.pageresult = response.data;
          }else{
            that.$message.error(response.message);
          }
        }
      })
    },
    // 下载文件
    download (data) {
        if (!data) {
            return
        }
        let url = window.URL.createObjectURL(new Blob([data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.target = "_blank";
        link.href = url
        link.setAttribute('download', '订单明细.xlsx')

        document.body.appendChild(link)
        link.click()
    },
    handleExcel(){
      let info = this.$store.state.userInfo;
      this.formSearch.merchno=info.userbh;
      this.$download('coupon-system/merch/downloadOrderExcel',this.formSearch).then((res) => {
        this.download(res)
      }).catch(err => {
        this.$message.error("下载失败");
     })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/merch/order.vue